import React, { Component } from 'react';
import InputMask from '../input_mask/InputMask';
// import MaskedInput from 'react-maskedinput';
import { Button, Input, Table } from 'antd';
import { makeMsisdnBeautiful } from '../../Utils';
import TEXTS from '../../locale/texts';

class AddMsisdns extends Component {
  state = {
    msisdn: '',
    tableData: [],
    message: '',
    hasSame: false
  };

  msisdnInput = React.createRef();

  componentDidMount() {
    setTimeout(() => {
      this.msisdnInput.current.focus();
    }, 0);
  }

  onInputChange = (event) => {
    const msisdnValue = event.target.value.replace(/\D/g, '');

    this.setState({
      msisdn: msisdnValue,
      message: ''
    });
  };

  onMsisdnEnterClicked = () => {
    const { msisdn } = this.state;

    if (msisdn.length === 11) {
      this.addMsisdn();
    }
  };

  onCancel = () => {
    const { hideDrawer } = this.props;

    this.setState({
      msisdn: '',
      msisdns: [],
      tableData: [],
      message: ''
    });

    hideDrawer();
  };

  addMsisdn = () => {
    const { msisdn, tableData } = this.state;
    const { lang } = this.props;
    const tableDataList = [...tableData];
    const sameMsisdn = tableDataList.filter(el => el.msisdn === msisdn).length;

    if (sameMsisdn === 0) {
      tableDataList.push({ msisdn: msisdn });

      this.setState({
        tableData: tableDataList,
        message: TEXTS.msisdnIsAdded[lang],
        hasSame: false
      });
    } else {
      this.setState({
        message: TEXTS.msisdnIsAlreadyAdded[lang],
        hasSame: true
      });
    }
  };

  addToCampaign = () => {
    const { updateMsisdns, hideDrawer } = this.props;
    const { tableData } = this.state;
    const msisdns = tableData.map(({ msisdn }) => ({
      msisdn, param1: '', param2: '', param3: '', param4: ''
    }));

    updateMsisdns(msisdns, 'withParamsDisabled');

    this.setState({
      msisdn: '',
      tableData: []
    });

    hideDrawer();
  };

  render() {
    const { lang } = this.props;
    const { msisdn, tableData, message, hasSame } = this.state;
    const msisdns = tableData.map(i => i.msisdn);

    const columns = [{
      title: TEXTS.contactPhoneLabel[lang],
      dataIndex: 'msisdn',
      render: (text) => makeMsisdnBeautiful(text)
    }];

    return (
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="t-light">{TEXTS.btnAddReceivers[lang]}</h3>
          <div>
            {msisdns.length > 0 &&
              <Button
                type="primary"
                size="large"
                style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
                onClick={this.addToCampaign}
              >
                {TEXTS.btnSave[lang]}
              </Button>}
            <Button
              style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
              onClick={this.onCancel}>
              {TEXTS.btnCancel[lang]}
            </Button>
          </div>
        </div>
        <div className="mb-5">
          <label className="t-bold">{TEXTS.contactPhoneLabel[lang]}</label>
          <div className="mb-lg-0 d-flex">
            <div className="position-relative">
              <InputMask
                _ref={this.msisdnInput}
                onChange={this.onInputChange}
                onPressEnter={this.onMsisdnEnterClicked}
                mask="+7-999-999-99-99"
                value={msisdn}
              />
              {message
                && <span className="position-absolute" style={{display: 'block',
                  color: hasSame ? '#ff4d4f' : '#52c41a'
                }}>{message}</span>}
            </div>
            <Button
              style={{padding: '0 20px', height: 40, marginLeft: 15, fontSize: 14}}
              type="primary"
              disabled={msisdn.length !== 11}
              onClick={this.addMsisdn}
            >
              {TEXTS.btnAddMsisdn[lang]}
            </Button>
          </div>
        </div>
        {msisdns.length > 0 &&
          <Table
            columns={columns}
            dataSource={tableData}
            rowKey={({ msisdn }) => msisdn}
            size="middle"
          />}
      </div>
    );
  }
}

export default AddMsisdns;
